import React from 'react';
import PropTypes from 'prop-types';
import { ErrorListWrapper } from './styles';

const listErrors = (errors) =>
  Object.values(errors).map((error, i) =>
    typeof error === 'object' ? listErrors(error) : <li key={i}>{error}</li>
  );

const ErrorList = ({ errors }) => (
  <ErrorListWrapper role="alert">
    <p>There are errors on this form</p>
    <ul>{listErrors(errors)}</ul>
  </ErrorListWrapper>
);

export default ErrorList;

ErrorList.propTypes = {
  errors: PropTypes.object,
};
